import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AppService } from "src/app/app.service";
import { CompanyDataService } from "../company-data.service";
@Component({
  selector: "app-resource-download",
  template: "",
})
export class ResourceDownloadComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private appService: AppService,
    private dataService: CompanyDataService,
  ) {}

  ticker: string;
  ngOnInit() {
    this.route.params.subscribe((param) => {
      this.ticker = decodeURIComponent(param.ticker);
      if (
        param.downloadType === "model" &&
        this.ticker &&
        param.param1 &&
        param.param2 &&
        param.param3
      ) {
        const extraParams = {
          companyId: param.param2,
          cut: "HOME",
          source: param.param1,
          pg: "",
          transactionId: param.param3,
        };

        this.appService.excelDownload("model_download", extraParams);
        this.router.navigateByUrl(`/company/${this.ticker}`);
      } else if (
        param.downloadType === "tearsheet" &&
        this.ticker &&
        param.param1 &&
        param.param2 &&
        param.param3
      ) {
        let privateIPOfUser = "";
        try {
          this.appService.getUserIP((ip) => {
            privateIPOfUser = ip;
          });
        } catch (err) {
          privateIPOfUser = "";
        }
        const tearurlParams = `ticker=${this.ticker}&type=${param.param1}&source=${param.param2}&tabid=${window.b_tab}&focus=${param.param3}&userIP=${privateIPOfUser}`;

        // In case socket is already connected, then fire download call
        // else wait for it to connect
        if (window.socket && window.socket.connected) {
          this.dataService.downloadTearSheet(tearurlParams).subscribe();
        } else {
          window.addEventListener("socketConnected", () => {
            this.dataService.downloadTearSheet(tearurlParams).subscribe();
          });
        }

        this.router.navigateByUrl(`/company/${this.ticker}`);
      }
    });
  }
}
